import mongoose from "mongoose";
import { PipelineStage } from "mongoose";
import { z, ZodTypeAny } from "zod";

export type ResourcePipelines = {
  _z: ZodTypeAny;
  mainStages?: PipelineStage[];
  projectStage?: PipelineStage.Project["$project"];
} & Record<string, any>;

export type ResourceSubPipeline = {
  mainStages: PipelineStage[];
  projectStage: PipelineStage.Project["$project"];
};

export async function populateResourceFromDoc<T extends ResourcePipelines>(
  id: mongoose.Types.ObjectId,
  model: mongoose.Model<any, any>,
  pipelines: T,
): Promise<z.input<T["_z"]> | null> {
  const pipeline: PipelineStage[] = [{ $match: { _id: id } }];

  if (pipelines["mainStages"]) {
    pipeline.push(...pipelines["mainStages"]);
  }

  if (pipelines["projectStage"]) {
    pipeline.push({ $project: pipelines["projectStage"] });
  }

  const aggregationResult = await model.aggregate(pipeline);

  if (!aggregationResult.length) {
    return null;
  }

  return aggregationResult[0];
}
